import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';

@Component({
  selector: 'app-license-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalHeaderComponent,
    LoaderComponent
  ],
  templateUrl: './license-form.component.html',
  styleUrl: './license-form.component.scss'
})
export class licenseFormComponent implements OnInit {
  @Input() item: any | null = null;
  @Input() organisationId: string | null = '';
  @Input() modalInstance: any = null;

  public modalTitle: string = "Licentie aanmaken";

  organisations: any = [];
  courses: any = [];
  chapters: any = [];
  periods: any = [];
  courseSections: any = [];
  errorMessage: string | null = null;
  errors: any = {};
  loading: boolean = false;
  newPassword: string = '';

  constructor(
    private apiService: ApiService,
  ) {
  }

  ngOnInit(): void {
    if (this.item != null) {
      this.loading = true;

      this.item['period_id'] = this.item['period']['id'];
      this.item['course_section_id'] = this.item['section']['id'];
      this.item['course_id'] = this.item['course']['id'];
      this.item['chapter_id'] = this.item['chapter']['id'];

      this.getCourseSections(true);
    } else {
      this.item = {};
    }

    if (this.organisationId) {
      this.item['organisation_id'] = this.organisationId;
    }

    this.getCourses();
    this.getSubjects();
    this.getStudyLevels();
    this.getPeriods();
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    let method: string = 'put';
    if (this.item['id'] === undefined) {
      let postData = this.item;

      return this.apiService.post('/office/licenses', postData).then(function (response: any) {
        self.handleSucces();
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      let postData = this.item;

      return this.apiService.put('/office/licenses/' + this.item['id'], postData).then(function (response: any) {
        self.handleSucces();
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces() {
    let self = this;
    setTimeout(function () {
      self.loading = false;
      self.modalInstance.close(true);
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = null;
  }

  getCourses() {
    let self = this;

    return this.apiService.get('/office/courses').then(function (response: any) {
      self.courses = response['data'];
    }).catch(function (e) {
    });
  }

  getPeriods() {
    let self = this;

    return this.apiService.get('/office/periods').then(function (response: any) {
      self.periods = response['data'];
    }).catch(function (e) {
    });
  }

  getCourseSections(updateSections = false) {
    let self = this;

    this.courseSections = [];
    this.chapters = [];

    return this.apiService.get('/office/courses/' + this.item['course_id'] + '/sections').then(function (response: any) {
      self.courseSections = response;

      if (updateSections) {
        self.setChapters();
        self.loading = false;
      }
    }).catch(function (e) {
    });
  }

  setChapters(course_section_id: any = null) {
    if (course_section_id !== null) {
      this.item['course_section_id'] = course_section_id;
    }
    const section = this.courseSections.find((course: any) => course.id == this.item['course_section_id']);
    if (section) {
      this.chapters = section.chapters;
    }
  }

  getSubjects() {
    let self = this;

    return this.apiService.get('/office/subjects').then(function (response: any) {
      self.organisations = response['data'];
    }).catch(function (e) {
    });
  }

  getStudyLevels() {
    let self = this;

    return this.apiService.get('/office/study-levels?limit=999').then(function (response: any) {
      self.organisations = response['data'];
    }).catch(function (e) {
    });
  }
}
